<template>
  <div class="manager-container">
    <!-- 顶部导航栏 -->
    <header class="top-nav">
      <div class="logo-container">
        <div class="logo-icon">
          <i class="el-icon-data-line"></i>
        </div>
        <div class="logo-text"> {{$platformName }}---数据管理平台</div>
      </div>

      <div class="user-info">
        <span class="user-name">管理员: {{ adminInfo.name }}</span>
        <span class="user-id">ID: {{ adminInfo.id }}</span>
        <el-button type="text" icon="el-icon-switch-button" class="logout-btn" @click="handleLogout">
          退出登录
        </el-button>
      </div>
    </header>

    <div class="main-content">
      <!-- 左侧导航栏 -->
      <aside class="sidebar">
        <el-menu default-active="home" class="el-menu-vertical-demo" @select="handleMenuSelect"
          background-color="#001529" text-color="#c0c4cc"
          active-text-color="#ffffff"
          :collapse="isCollapse"
          >
          <!-- 首页 -->
          <el-menu-item index="home">
            <el-icon class="menu-icon">
              <HomeFilled />
            </el-icon>
            <span slot="title">首页</span>
          </el-menu-item>

          <!-- 科研成果管理 -->
          <el-menu-item index="scientific-achievements">
            <el-icon class="menu-icon">
              <Monitor />
            </el-icon>
            <span slot="title">科研成果管理</span>
          </el-menu-item>

          <!-- 技术需求管理 -->
          <el-menu-item index="technical-needs">
            <el-icon class="menu-icon">
              <HelpFilled />
            </el-icon>
            <span slot="title">技术需求管理</span>
          </el-menu-item>

          <!-- 高校院所管理 -->
          <el-menu-item index="institution-manager">
            <el-icon class="menu-icon">
              <School />
            </el-icon>
            <span slot="title">高校/机构管理</span>
          </el-menu-item>

          <!-- 科研机构管理 -->
          <!-- <el-menu-item index="research-institutions">
            <el-icon class="menu-icon">
              <OfficeBuilding />
            </el-icon>
            <span slot="title">科研机构管理</span>
          </el-menu-item> -->

          <!-- 人才智库管理 -->
          <el-menu-item index="expert-manager">
            <el-icon class="menu-icon">
              <UserFilled />
            </el-icon>
            <span slot="title">人才智库管理</span>
          </el-menu-item>

          <!-- 仪器共享管理 -->
          <el-menu-item index="instrument-sharing">
            <el-icon class="menu-icon">
              <Cpu />
            </el-icon>
            <span slot="title">仪器共享管理</span>
          </el-menu-item>

          <!-- 科技金融管理
          <el-menu-item index="tech-finance">
            <el-icon class="menu-icon">
              <Money />
            </el-icon>
            <span slot="title">科技金融管理</span>
          </el-menu-item> -->

          <!-- 政策资讯管理 -->
          <!-- <el-menu-item index="policy-news">
            <el-icon class="menu-icon">
              <Document />
            </el-icon>
            <span slot="title">政策资讯管理</span>
          </el-menu-item> -->

          <!-- 首页轮播图管理 -->
          <!-- <el-menu-item index="carousel">
            <el-icon class="menu-icon">
              <Picture />
            </el-icon>
            <span slot="title">首页轮播图管理</span>
          </el-menu-item> -->

          <!-- 管理员信息 -->
          <!-- <el-menu-item index="admin-info">
            <el-icon class="menu-icon">
              <Setting />
            </el-icon>
            <span slot="title">管理员信息</span>
          </el-menu-item> -->
        </el-menu>

        <div class="collapse-btn" @click="toggleCollapse">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
      </aside>

      <section class="content-area">
        <router-view v-if="this.$route.path!='/manager/home'"/>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManagerDashboard',
  data() {
    return {
      // 管理员信息
      adminInfo: {
        name: '张三',  // 实际应用中从登录信息获取
        id: 'ADM001'   // 实际应用中从登录信息获取
      },
      // 侧边栏是否折叠
      isCollapse: false
    }
  },
  created() {
    // 从本地存储获取管理员信息
    this.loadAdminInfo();
  },
  methods: {
    // 加载管理员信息
    loadAdminInfo() {
      const userInfo = localStorage.getItem('currentUser');
      if (userInfo) {
        this.adminInfo = JSON.parse(userInfo);
      }
    },

    // 处理菜单选择，跳转路由
    handleMenuSelect(index) {
      this.$router.push(`/manager/${index}`);
    },

    // 切换侧边栏折叠状态
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    handleLogout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('rememberedUser');
        this.$router.push('/m/login');
        this.$message.success('退出登录成功');
      }).catch(() => {
        this.$message.info('已取消退出登录');
      });
    }
  }
}
</script>

<style scoped>
.manager-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* 顶部导航栏样式 */
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background-color: #001529;
  color: #fff;
  padding: 0 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-icon {
  font-size: 24px;
  margin-right: 10px;
  color: #1890ff;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-name {
  margin-right: 15px;
}

.user-id {
  margin-right: 20px;
  color: #ccc;
  font-size: 14px;
}

.logout-btn {
  color: #fff;
  border-left: 1px solid #333;
  padding-left: 15px;
}

/* 主内容区域样式 */
.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* 侧边栏样式 */
.sidebar {
  width: 200px;
  background-color: #001529;
  color: #fff;
  display: flex;
  flex-direction: column;
  transition: width 0.3s;
}

.sidebar.collapsed {
  width: 64px;
}

.el-menu-vertical-demo {
  border-right: none;
  height: 100%;
}

.collapse-btn {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
  cursor: pointer;
  border-top: 1px solid #1f2d3d;
}

.collapse-btn:hover {
  color: #fff;
  background-color: #1f2d3d;
}

/* 内容区域样式 */
.content-area {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background-color: #f5f7fa;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .sidebar {
    width: 64px;
  }

  .isCollapse {
    width: 200px;
  }

  .logo-text {
    display: none;
  }

  .sidebar:hover {
    width: 200px;
  }

  .sidebar:hover+.content-area {
    margin-left: 200px;
  }
}
</style>
